import { forwardRef } from 'react';
import { css } from '@emotion/react';
import type { CommonHTMLAttributes } from '@frontend/types';

export type UlProps = CommonHTMLAttributes & {
  children?: React.ReactNode;
};

export const NakedUl = forwardRef<HTMLUListElement, UlProps>(({ children, ...rest }, ref) => (
  <ul
    css={css`
      list-style-type: none;
      padding-left: 0;
    `}
    {...rest}
    ref={ref}
  >
    {children}
  </ul>
));
NakedUl.displayName = 'NakedUl';
